<template>
  <div class="filter-wrapper">
    <div class="filter-options">
      <v-form v-bind="this.$attrs">
        <v-row>
          <v-col cols="12" sm="12" md="10">
            <v-row>
              <v-col cols="12" sm="12" md="5">
                <AutocompleteAcademicLevel
                  v-model="academicLevel"
                  clear-icon="mdi-close"
                  item-text="title"
                  item-value="id"
                  label="Bộ môn"
                  clearable
                  outlined
                  dense
                  hide-details
                  return-object
                  @change="gradeChanged"
                />
              </v-col>
              <v-col cols="12" sm="12" md="5">
                <v-text-field
                  v-model="title"
                  clear-icon="mdi-close"
                  label="Tên chương trình đào tạo"
                  flat
                  outlined
                  dense
                  clearable
                  hide-details
                  @keyup.enter="onFilterChanged"
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col class="d-flex align-end" cols="12" sm="12" md="2">
            <v-btn class="search-button" :class="{ 'px-2': windowWidth < 1100 }" @click="onFilterChanged" outlined>
              Tìm kiếm
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import get from 'lodash-es/get'
import AutocompleteAcademicLevel from '@/components/basic/input/AutocompleteAcademicLevel.vue'

export default {
  components: {
    AutocompleteAcademicLevel,
  },
  data: () => ({
    academicLevel: {},
    show: false,
    status: 'active',
    title: '',
    windowWidth: window.innerWidth,
  }),
  props: {
    defaultFilters: Object,
  },
  computed: {
    ...mapState('constant', ['studentStatus']),
    classFilter() {
      return { academicLevel: get(this.academicLevel, 'id') }
    },
  },
  methods: {
    onFilterChanged() {
      this.$emit('onFilterChanged', {
        title_contains: this.title,
        academicLevel: get(this.academicLevel, 'id'),
      })
    },
    gradeChanged(academicLevel) {
      this.academicLevel = academicLevel
    },
    onResize() {
      this.windowWidth = window.innerWidth
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
    clearInterval(this.interval)
  },
}
</script>
<style lang="scss" scoped>
.filter-wrapper {
  display: flex;
  gap: 24px;

  @media screen and (max-width: 960px) {
    flex-direction: column;
  }
  .filter-options {
    flex: 1;
  }
}
</style>
